module.exports = __webpack_public_path__ + "static/media/london_25-sits_oppet_avslut_tyg_mito_detalj_2023_4_fyrkant.a9629555.jpg";